import React from 'react';
import { classes, st } from '../EntityAdvancedPermissions.st.css';
import { Box, Text as BO_Text } from '@wix/design-system';
import { Text, TextTypography } from 'wix-ui-tpa';
import { Dismiss } from '@wix/wix-ui-icons-common';
import CloseLogo from '../../assets/icons/Close.svg';
import { STEP_2 } from '../common/constants';
export const Header = (props) => {
    const { isDashboard, modalTitle, modalSubtitle, step, mobile, backToFirstView, isModal, closeAriaLabel, closeCallback, } = props;
    const multiLineMobileClass = mobile ? classes.twoLinesEllipsis : '';
    const onCloseIconKeyDown = (e) => {
        if (e.key === 'Enter') {
            closeCallback();
        }
    };
    return (React.createElement("div", { className: st(classes.header) },
        React.createElement("div", { className: st(classes.titleContainer, {
                secondView: step === STEP_2,
            }), tabIndex: 0 }, isDashboard ? (React.createElement(Box, { direction: "horizontal", display: "grid" },
            React.createElement(BO_Text, { id: "modalMainTitle", weight: "bold", size: "medium", ellipsis: true, className: st(classes.wsrModalMainTitle) }, modalTitle),
            React.createElement(BO_Text, { id: "folderName", className: st(classes.wsrFolderName), ellipsis: true }, modalSubtitle))) : (React.createElement(React.Fragment, null,
            React.createElement(Text, { id: "modalMainTitle", typography: TextTypography.smallTitle, className: st(classes.modalMainTitle, multiLineMobileClass) }, modalTitle),
            React.createElement(Text, { id: "folderName", typography: TextTypography.runningText, className: st(classes.folderName, multiLineMobileClass) }, modalSubtitle)))),
        isModal &&
            (isDashboard ? (React.createElement(Dismiss, { className: st(classes.closeButton), onClick: closeCallback, "aria-label": closeAriaLabel, onKeyDown: onCloseIconKeyDown, tabIndex: 0 })) : mobile ? (React.createElement(React.Fragment, null)) : (React.createElement(CloseLogo, { className: st(classes.closeButton), onClick: closeCallback, role: "button", tabIndex: 0, onKeyDown: onCloseIconKeyDown, "aria-label": closeAriaLabel })))));
};
//# sourceMappingURL=Header.js.map